__turbopack_context__.v({
  "button": "IconButton-module__lPWyma__button",
  "icon": "IconButton-module__lPWyma__icon",
  "isDisabled": "IconButton-module__lPWyma__isDisabled",
  "sizeM": "IconButton-module__lPWyma__sizeM",
  "sizeS": "IconButton-module__lPWyma__sizeS",
});
